import LightClientApi from '@openclassrooms/sdk';
import type { ClientApi } from '@openclassrooms/sdk-web';
import type OCAISDK from '@openclassrooms/js-ai-sdk';

export default (() => {
  let ocClient: ClientApi | null = null;
  let lightOcClient: LightClientApi<APIEndpoints> | null = null;
  let aiClient: OCAISDK | null = null;

  return {
    setOCClient(newClient: ClientApi) {
      ocClient = newClient;
    },
    getOCClient(): ClientApi {
      // istanbul ignore next
      if (!ocClient) {
        throw new ReferenceError(
          '[data-connect-web] calling getOCClient() but no client has been set: did you forget to call setOCClient()?'
        );
      }

      return ocClient;
    },

    setLightOCClient(newClient: LightClientApi<APIEndpoints>) {
      lightOcClient = newClient;
    },
    getLightOCClient(): LightClientApi<APIEndpoints> {
      // istanbul ignore next
      if (!lightOcClient) {
        throw new ReferenceError(
          '[data-connect-web] calling getLightOCClient() but no client has been set: did you forget to call setLightOCClient()?'
        );
      }

      return lightOcClient;
    },

    setAIClient(newClient: OCAISDK) {
      aiClient = newClient;
    },

    getAIClient(): OCAISDK {
      // istanbul ignore next
      if (!aiClient) {
        throw new ReferenceError(
          '[data-connect-web] calling getAIClient() but no client has been set: did you forget to call setAIClient()?'
        );
      }

      return aiClient;
    },
  };
})();
